export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacje o kontrahencie"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Konto / E-mail / Telefon"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Adres kryptograficzny / E-mail / Telefon"])}
}